import React from 'react';

interface MetricTogglePanelProps {
  selectedMetrics: string[];
  onMetricToggle: (metric: string) => void;
}

const AVAILABLE_METRICS = [
  { key: 'generation', label: 'Generation (kWh)', color: 'bg-blue-500' },
  { key: 'cuf', label: 'CUF (%)', color: 'bg-purple-500' }
];

export const MetricTogglePanel: React.FC<MetricTogglePanelProps> = ({
  selectedMetrics,
  onMetricToggle
}) => {
  return (
    <div className="flex flex-wrap gap-2 p-4 bg-gray-50 rounded-lg">
      <span className="text-sm font-medium text-gray-700 mr-2">Show Metrics:</span>
      {AVAILABLE_METRICS.map((metric) => (
        <button
          key={metric.key}
          onClick={() => onMetricToggle(metric.key)}
          className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium transition-colors ${
            selectedMetrics.includes(metric.key)
              ? `${metric.color} text-white`
              : 'bg-white text-gray-600 border border-gray-300 hover:bg-gray-100'
          }`}
        >
          <div
            className={`w-2 h-2 rounded-full mr-2 ${
              selectedMetrics.includes(metric.key) ? 'bg-white' : metric.color
            }`}
          />
          {metric.label}
        </button>
      ))}
    </div>
  );
};